import { ROUTE_MULTI_DISEASE_WELCOME } from '@/constants/routes';
import { RouteObject } from 'react-router-dom';
import Page from './multi-disease-welcome.page';

export const routeMultiDiseaseWelcome: RouteObject = {
  path: ROUTE_MULTI_DISEASE_WELCOME,
  element: <Page />,
};
